import debounce from 'lodash/debounce'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import DownTriangleIcon from '../../../assets/v2/JSX/DownTriangleIcon'
import StarIcon from '../../../assets/v2/JSX/StarIcon'
import Loader from '../../../components/Loader'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import ToggleSwitcher from '../../../components/v2/buttons/ToggleSwitcher'
import GreenTick from '../../../assets/v2/JSX/GreenTick'
import RedCross from '../../../assets/v2/JSX/RedCross'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../store'
import {
  HealthState,
  setChooseMethod,
  setHeaderPassedCount,
  setOffer,
  setPaymentScheduleArr,
} from '../../../store/healthSlice'
import GetBetterOffer from '../../../components/v2/GetBetterOffer'
import HealthProgressbar from '../../../components/v2/progrees-bars/HealthProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { AppState } from '../../../store/appSlice'

//
const HealthOffers = () => {
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { health: HealthState }) => data.health)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const HealthCompanies = filter.companyOffers
  //
  const [selectedAccordion, setSelectedAccordion] = useState<number[] | []>([])
  //
  //
  const toggleAccordion = (index: number) => {
    // open && add new index in array
    if (index) {
      setSelectedAccordion([...selectedAccordion, index])
    }

    // close && remove current index from
    if (index && selectedAccordion.find((x) => x === index)) {
      setSelectedAccordion([...selectedAccordion.filter((x) => x !== index)])
    }
  }
  //
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  //
  useEffect(() => {
    const handleResize = debounce(() => setScreenWidth(window.innerWidth), 100)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  //
  //
  const fakeData = {
    translations: {
      ge: {
        stepName: 'შეთავაზებები',
      },
      en: {
        stepName: 'offers',
      },
    },
  }
  //
  const stepName = fakeData.translations[lang].stepName
  //
  //
  //declaring choose method if someone visits via url
  useEffect(() => {
    dispatch(setChooseMethod('my-choice'))
  }, [dispatch])
  //
  //
  const isHealthOffersLoading = false
  const mainLoader = isHealthOffersLoading
  //
  return mainLoader ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('chooseOffer')} />

        <HealthProgressbar stepName={stepName} />

        <Container>
          <Schedule>
            <span
              style={{
                color: filter.paymentSchedule?.id === 1 ? Colors.nevadaGrey : Colors.primaryBlack,
              }}
            >
              {t('monthly')}
            </span>
            <ToggleSwitcherStyle
              activeRedBackground={true}
              defaultValue={filter?.paymentSchedule?.type === 'MONTHLY' ? false : true}
              onChange={(value) => {
                if (value === true) {
                  return [
                    dispatch(
                      setPaymentScheduleArr({
                        id: 1,
                        type: 'ONE-TIME',
                      }),
                    ),
                  ]
                } else {
                  return [
                    dispatch(
                      setPaymentScheduleArr({
                        id: 2,
                        type: 'MONTHLY',
                      }),
                    ),
                  ]
                }
              }}
            />
            <span
              style={{
                color: filter.paymentSchedule?.id === 2 ? Colors.nevadaGrey : Colors.primaryBlack,
              }}
            >
              {t('annual')}
            </span>
          </Schedule>

          <Block>
            {HealthCompanies?.map((item, index) => {
              const currentIndex = index + 1

              return (
                <BestOfferCard
                  key={index}
                  $isBestPrice={item?.isBest ? item.isBest : false}
                  $selected={item?.companyId === filter.offer?.companyId ? true : false}
                >
                  {item?.isBest && (
                    <BestPriceDiv>
                      <StarIcon />
                      <span>{t('bestOffer')}</span>
                    </BestPriceDiv>
                  )}

                  <Head
                    style={{
                      marginBottom:
                        screenWidth <= 1200
                          ? selectedAccordion.find((x) => x === currentIndex)
                            ? '24px'
                            : '0px'
                          : '28px',
                    }}
                    onClick={() => {
                      toggleAccordion(currentIndex)
                    }}
                  >
                    <ArrowBtn
                      $selectedAccordion={selectedAccordion}
                      $currentIndex={currentIndex}
                      $screenWidth={screenWidth}
                    >
                      <DownTriangleIcon />
                    </ArrowBtn>
                    <CompanyInfo>
                      <img src={item?.companyLogo} alt={item?.companySlug} />
                      <span>{item?.brandName?.[lang]?.title}</span>
                    </CompanyInfo>

                    <RadioButtonStyle onClick={() => toggleAccordion(currentIndex)}>
                      <CircleStatus
                        onClick={() => {
                          dispatch(setOffer(item))
                        }}
                        key={index}
                        $selected={item?.companyId === filter.offer?.companyId ? true : false}
                      />
                    </RadioButtonStyle>
                  </Head>

                  <InnerContent
                    style={{
                      display:
                        screenWidth <= 1200
                          ? selectedAccordion.find((x) => x === currentIndex)
                            ? 'block'
                            : 'none'
                          : 'block',
                    }}
                  >
                    <GetBetterOffer
                      defaultValue={false}
                      onChange={(value) => {
                        // alert('function')
                      }}
                      title={t('getBetterOffer')}
                      description={t('freeChoice')}
                    />
                    <HR />

                    <DescriptionBlock>
                      <UTitle>
                        <li>{t('service')}</li>
                        <li>{t('healthLimit')}</li>
                        <li>{t('coPayment')}</li>
                      </UTitle>
                      <Ul>
                        <li>{t('ambulatory')}</li>
                        <li>{item?.packageServices?.ambulatory?.limit} %</li>
                        <li>{item?.packageServices?.ambulatory?.payment} ₾</li>
                      </Ul>
                      <Ul>
                        <li>{t('medicines')}</li>
                        <li>{item?.packageServices?.medicines?.limit} %</li>
                        <li>{item?.packageServices?.medicines?.payment} ₾</li>
                      </Ul>
                      <Ul>
                        <li>{t('hospitilazition')}</li>
                        <li>{item?.packageServices?.hospitalization?.limit} %</li>
                        <li>{item?.packageServices?.hospitalization.payment} ₾</li>
                      </Ul>
                      <Ul>
                        <li>{t('dentistry')}</li>
                        <li>{item?.packageServices?.dentistry?.limit} %</li>
                        <li>{item?.packageServices?.dentistry?.payment} ₾</li>
                      </Ul>
                    </DescriptionBlock>
                    <br />

                    <ServicesBlock>
                      <TitleBlock>
                        <ServicesTitle>{t('service')}</ServicesTitle>
                        <ServicesTitle>{t('waitingPeriod')}</ServicesTitle>
                      </TitleBlock>

                      <TextDiv>
                        <LeftText>{t('plannedHospitalization')}</LeftText>
                        <RightText>{item?.services.hospitalization.waitingPeriod + ' ' + t('month')}</RightText>
                      </TextDiv>

                      <TextDiv>
                        <LeftText>{t('pregnancy/Childbirth')}</LeftText>
                        <RightText>{item.services.pregnancy.waitingPeriod + ' ' + t('month')}</RightText>
                      </TextDiv>

                      <TextDiv>
                        <LeftText>
                          {item?.services?.medicines.covered &&
                            item?.services?.medicines.covered === true &&
                            t('medicinesForIllness')}
                        </LeftText>
                        <RightText>
                          {item?.services?.medicines.covered &&
                            item?.services?.medicines.covered === true &&
                            `${item.services?.medicines?.waitingPeriod} ${t('month')}`}
                        </RightText>
                      </TextDiv>
                    </ServicesBlock>

                    <HR />

                    <ServicesBlock>
                      <ServicesTitle>{t('service')}</ServicesTitle>

                      <TextDiv>
                        <LeftText>{t('plannedHospitalization')}</LeftText>
                        <RightText>
                          {item?.services?.hospitalization.covered === true ? <GreenTick /> : <RedCross />}
                        </RightText>
                      </TextDiv>

                      <TextDiv>
                        <LeftText>{t('dayHospitalization')}</LeftText>
                        <RightText>
                          {item?.services?.dayHospitalization.covered === true ? <GreenTick /> : <RedCross />}
                        </RightText>
                      </TextDiv>

                      <TextDiv>
                        <LeftText>{t('pregnancy/Childbirth')}</LeftText>
                        <RightText>
                          {item?.services?.pregnancy.covered === true ? <GreenTick /> : <RedCross />}
                        </RightText>
                      </TextDiv>
                    </ServicesBlock>
                    <HR />

                    <PriceWrapper>
                      <PriceText>
                        {filter.paymentSchedule?.type === 'MONTHLY'
                          ? `${item.calculatedPrices.monthly} ₾/${t('month')}`
                          : `${item.calculatedPrices.annual} ₾`}
                      </PriceText>

                      <ATagStyle href={item.productWording} target="_blank">
                        <div>{t('policyTerms')}</div>
                      </ATagStyle>
                    </PriceWrapper>
                  </InnerContent>

                  {/* {item} */}
                </BestOfferCard>
              )
            })}
          </Block>
        </Container>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => [setHeaderPassedCount(screenHeader.passedCount - 1), navigate('/health-choose-method')]}
          />
          <NavigationButton
            disabled={filter.offer ? false : true}
            text={`${t('next')}`}
            buttonType="next"
            onClick={() => [dispatch(setHeaderPassedCount(6)), navigate('/health-offer')]}
          />
        </Buttons>
      </Content>

      <BackgroundIcon shortKite={true} />
    </Wrapper>
  )
}
//

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 100px;
  min-height: 100vh;
  ${Responsive.tablet} {
    padding-bottom: 65px;
  }
  ${Responsive.mobile} {
    padding-bottom: 56px;
  }
`
const Content = styled.div`
  margin-top: 58px;
  width: 100%;
  z-index: 1;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`

const Schedule = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 32px;
  gap: 10px;

  span {
    font-size: 18px;
    line-height: 17px;
    color: ${Colors.primaryBlack};
  }
  svg {
    color: ${Colors.secondaryGrey};
  }

  ${Responsive.mobile} {
    margin-block: 24px;
  }
`

const Card = styled.div`
  background-color: ${Colors.white};
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  border-radius: 8px;
  padding: 48px;
  position: relative;
  z-index: 3;

  ${Responsive.laptop} {
    padding: 30px;
  }

  ${Responsive.tablet} {
    padding: 40px;
  }

  ${Responsive.mobile} {
    padding: 28px 20px;
  }
`

const BestOfferCard = styled(Card)<{ $isBestPrice: boolean; $selected: boolean }>`
  width: 100%;
  max-width: ${({ $isBestPrice }) => ($isBestPrice ? '504px' : '464px')};
  position: relative;
  padding-top: ${({ $isBestPrice }) => ($isBestPrice === true ? `55px` : `40px`)};
  border: ${({ $selected }) => ($selected === true ? `1px solid ${Colors.primaryBlack}` : 'none')};

  ${Responsive.laptop} {
    padding-top: ${({ $isBestPrice }) => ($isBestPrice === true ? `55px` : `40px`)};
  }

  ${Responsive.tablet} {
    padding-top: ${({ $isBestPrice }) => ($isBestPrice === true ? `50px` : `40px`)};
    max-width: unset;
  }

  ${Responsive.mobile} {
    padding-top: ${({ $isBestPrice }) => ($isBestPrice === true ? `45px` : `25px`)};
    max-width: unset;
  }
`

const Block = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;

  ${BestOfferCard} {
    &:not(:last-child) {
      margin-right: 32px;
    }
  }
  /*  */
  ${Responsive.tablet} {
    flex-direction: column;

    ${BestOfferCard} {
      &:not(:last-child) {
        margin-right: 0px;
        margin-bottom: 32px;
      }
    }
  }
  /*  */
  ${Responsive.mobile} {
    flex-direction: column;

    ${BestOfferCard} {
      &:not(:last-child) {
        margin-right: 0px;
        margin-bottom: 32px;
      }
    }
  }
`

const BestPriceDiv = styled.div`
  display: flex;
  align-items: center;
  background-color: ${Colors.lightRed};
  border-bottom-right-radius: 8px;
  height: 40px;
  width: fit-content;
  padding-inline: 24px;
  position: absolute;
  top: 0;
  left: 0;

  /*  */
  svg {
    height: 14px;
    width: 14.59px;
    color: ${Colors.primaryRed};
    stroke: ${Colors.primaryRed};
  }
  /*  */
  span {
    margin-left: 9px;
    font-size: 14px;
    color: ${Colors.primaryRed};
  }

  ${Responsive.tablet} {
    height: 32px;
    padding-inline: 14px;
  }
  ${Responsive.mobile} {
    height: 32px;
    padding-inline: 14px;
  }
`
const Head = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  ${Responsive.tablet} {
    justify-content: space-between;
    cursor: pointer;
  }
  ${Responsive.mobile} {
    justify-content: space-between;
    cursor: pointer;
  }
`
const ArrowBtn = styled.button<{
  $selectedAccordion: number[] | []
  $currentIndex: number | null
  $screenWidth: number | null
}>`
  transform: ${({ $selectedAccordion, $currentIndex }) =>
    $selectedAccordion.find((x) => x === $currentIndex) ? 'rotate(180deg)' : 'rotate(0deg)'};
  opacity: ${({ $screenWidth }) => ($screenWidth && $screenWidth <= 1200 ? 'unset' : '0')};
  user-select: ${({ $screenWidth }) => ($screenWidth && $screenWidth <= 1200 ? 'unset' : 'none')};
  pointer-events: ${({ $screenWidth }) => ($screenWidth && $screenWidth <= 1200 ? 'unset' : 'none')};
  width: ${({ $screenWidth }) => ($screenWidth && $screenWidth <= 1200 ? 'unset' : '0px')};
  outline: none;
  border: none;
  background-color: transparent;
  padding: 0px;
  margin: 0px;
  height: 15px;
  width: 15px;
  display: grid;
  place-items: center;

  svg {
    width: 14px;
    height: 7px;
  }
`

const CircleStatus = styled.div<{ $selected: boolean }>`
  z-index: 2;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: absolute;
  top: 15px;
  right: 15px;
  border: ${({ $selected }) => ($selected ? 'unset' : `solid 1px ${Colors.nevadaGrey}`)};
  box-shadow: ${({ $selected }) => ($selected ? `inset 0px 0px 0px 11px ${Colors.primaryRed}` : 'unset')};
  cursor: pointer;

  /*  */
  ${Responsive.mobile} {
    width: 26px;
    height: 26px;
    box-shadow: ${({ $selected }) => ($selected ? `inset 0px 0px 0px 9px ${Colors.primaryRed}` : 'unset')};
  }
`

const RightText = styled.div`
  text-align: right;
`
const LeftText = styled.div`
  width: 82%;

  ${Responsive.mobile} {
    width: 75%;
  }
`
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  &:not(:last-child) {
    margin-bottom: 14px;
  }
`

const DescriptionBlock = styled.div`
  width: 100%;
`
const Ul = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  list-style: none;
  padding-left: unset;
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 13px;
  align-items: center;
  li {
    text-align: right;
    :first-child {
      text-align: left;
    }
  }
  ${Responsive.mobile} {
    grid-template-columns: 40% 29% 29%;
  }
`
const UTitle = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  list-style: none;
  padding-left: unset;
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;

  li {
    text-align: right;
    :first-child {
      text-align: left;
    }
  }
  ${Responsive.mobile} {
    grid-template-columns: 40% 29% 29%;
  }
`
const ServicesBlock = styled.div`
  display: flex;
  flex-direction: column;
`

const TitleBlock = styled.div`
  display: flex;
  justify-content: space-between;
`

const InnerContent = styled.div`
  /*  */
`
const ATagStyle = styled.a`
  font-size: 14px;
  line-height: 18px;
  color: ${Colors.primaryBlack};
  text-align: right;
  font-weight: 500;
  padding-inline: 2px;
  text-decoration: underline;
  /*  */
  &:hover {
    color: ${Colors.primaryBlack};
  }
`
const HR = styled.hr`
  background-color: ${Colors.secondaryGrey};
  margin-block: 24px;
`
const RadioButtonStyle = styled.div`
  label {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  ${Responsive.mobile} {
    label {
      top: 15px;
      right: 15px;
    }
  }
`
const CompanyInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  /*  */
  img {
    height: 32px;
    margin-right: 10px;
  }
  /*  */
  span {
    font-size: 18px;
    color: ${Colors.primaryBlack};
  }

  /*  */
  ${Responsive.mobile} {
    img {
      height: 24px;
    }
  }
`

const PriceText = styled.div`
  font-size: 28px;
  color: ${Colors.primaryBlack};
  text-decoration: none;
  font-weight: bold;

  ${Responsive.mobile} {
    font-size: 24px;
  }
`
const ServicesTitle = styled.h6`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`
const ToggleSwitcherStyle = styled(ToggleSwitcher)`
  label {
    margin-left: 20px;
  }
`
const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

//
export default HealthOffers
